import * as React from 'react';
import {
	IStaticPageWrapperProps,
	StaticPageWrapper
} from 'components/static-pages/StaticPageWrapper';
import {UIState} from "data/UIState";
import './CustomLandingPage.pcss';
export const CustomLandingPage = (props:IStaticPageWrapperProps) => {

	const page = UIState.currentCustomPage;

	return (
		<StaticPageWrapper backgroundImage={page.bg} backgroundSize="cover" {...props}>
			<div className={"clp"}>
				{page.blocks.map((block, idx)=>{
					if(block.type==='text') {
						return <div key={idx} className={block.style}>{block.text}</div>;
					} else if(block.type==='image') {
						return <div key={idx} className={"logoWrapper"}><img src={block.url}/></div>;
					} else if(block.type==='html') {
						return <div key={idx} className={"htmlBlock"}><div dangerouslySetInnerHTML={{__html: block.text}}/></div>;
					} else if(block.type==='button') {
						return <div key={idx} className={"buttonWrapper"}><a className="three-band-focus" target="_blank" href={block.url} aria-label={`${block.text}, opens new tab`}>{block.text}</a></div>;
					} else {
						return null;
					}
				})}
			</div>
		</StaticPageWrapper>

);
};

